import styled from "styled-components";
import { IWithDisabled } from "../../../../ui/_common/IWithDisabled";
import { generic } from "../../../../ui/_themes/constants";

const textColor = generic.autoplaySettings.text.color;
const textDisabledColor = generic.autoplaySettings.text.disabled;

export const Wrapper = styled<IWithDisabled, "div">("div")`
  margin: 0 auto;
  width: 80%;
  color: ${({ disabled }) => (disabled ? textDisabledColor : textColor)};
`;

export const RowWrapper = styled<IWithDisabled, "div">("div")`
  display: block;
  padding-bottom: 1.5em;
  color: ${({ disabled }) => (disabled ? textDisabledColor : "unset")};
`;

export const Row = styled<IWithDisabled, "div">("div")`
  display: flex;
  justify-content: space-between;
  flex: 1 1 auto;
  color: ${({ disabled }) => (disabled ? textDisabledColor : "unset")};
  padding-top: 1em;
`;
